import { compact } from 'lodash'
import { deserialize } from 'cerialize'
import { CertificateModel, ShortDataModel } from 'Models'
import { StatusActModel, ActPermissions, ActCancelReasonModel } from 'Pages/acts'
import { getDate, getTime } from 'Helpers'

export class ActModel {
	@deserialize public id: number
	@deserialize public url?: string
	@deserialize public protocol_url?: string
	@deserialize public size?: number
	@deserialize public contract_number?: number
	@deserialize public filename?: string
	@deserialize public created_at?: string
	@deserialize public status_updated_at?: string
	@deserialize public partner_signing_at?: string
	@deserialize public ds_signing_at?: string
	@deserialize public act_date?: string
	@deserialize public period: string
	@deserialize public partner_signer_phone?: string
	@deserialize public status: StatusActModel
	@deserialize public permissions: ActPermissions
	@deserialize public status_translate?: string
	@deserialize public md5sum?: string
	@deserialize public next_available_statuses?: StatusActModel[]
	@deserialize public created_by_user?: ShortDataModel
	@deserialize public partner_signer?: string
	@deserialize public partner_signer_position?: string
	@deserialize public actual_partner_signer?: {
		id: number
		name: string
		email: string
		phone: string
	}
	@deserialize public ds_signer?: ShortDataModel
	@deserialize public failed_sms_input_count?: {
		current: number
		max: number
	}
	@deserialize public certificate_info?: CertificateModel
	@deserialize public ds_signature?: {
		size: number
		filename: string
		url: string
	}
	@deserialize public partner: {
		id: string
		name_full: string
		vat_number: string
		email: string
		manager: {
			id: string
			name: string
			territorial_bank: {
				id: string
				name: string
				code: string
				regions: ShortDataModel[]
			}
		}
	}
	@deserialize public cancel_reasons: ActCancelReasonModel[]
	@deserialize public is_promotion: boolean
	@deserialize public payment_number: string | null
	@deserialize public amount_of_remuneration?: number
	@deserialize public remark_reasons?: {
		id: number
		message: string
		created_at: string
	}[]
	@deserialize public is_vat: boolean

	public get current_status(): string | undefined {
		return this?.status?.status_slug_translate
	}
	public get partner_name(): string | undefined {
		return this?.partner?.name_full
	}
	public get manager_name(): string | undefined {
		return this?.partner?.manager?.name
	}
	public get territorial_bank_name(): string | undefined {
		return this?.partner?.manager?.territorial_bank?.name
	}
	// eslint-disable-next-line class-methods-use-this
	public get is_checkable(): boolean {
		return !!compact(Object.values(this.permissions)).length
	}

	public get is_partner_sign(): boolean | undefined {
		return this?.permissions?.partner_sign
	}
	public get is_cancel(): boolean | undefined {
		return this?.permissions?.cancel
	}
	public get is_delete(): boolean | undefined {
		return this?.permissions?.delete
	}
	public get is_ds_sign(): boolean | undefined {
		return this?.permissions?.ds_sign
	}
	public get inn(): string | undefined {
		return this?.partner?.vat_number
	}
	public get status_update(): string | undefined {
		return `${getDate(this.status_updated_at)} ${getTime(this.status_updated_at)}`
	}
}
